<template>
  <!--<div id="app">-->
    <!--&lt;!&ndash;<img src="./assets/logo.png">&ndash;&gt;-->
    <!--<router-view/>-->
  <!--</div>-->
  <div id="app">
    <!--<transition :name="transitionName">-->
      <router-view class="Router"></router-view>
    <!--</transition>-->
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      transitionName: 'slideleft',
      SkipSwitchName:''
    }
  },
  watch: {
    $route(to,form) {   // 监听路由变化重新赋值
//      console.log(this.$route)
      const toIndex=to.meta.index
      const formIndex=form.meta.index
      this.transitionName=formIndex>toIndex ? 'slideleft':'slideright'
    }
  }
}
</script>

<style>
/*#app {*/
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
/*}*/
#app {
  width: 100%;
  height: 100%;
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
}

.slideleft-enter,
.slideright-leave-active {
  opacity: 0;
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}
.slideleft-leave-active,
.slideright-enter {
  opacity: 0;
  -webkit-transform: translate(-100%, 0);
  transform: translate(-100%, 0);
}

</style>



// WEBPACK FOOTER //
// src/App.vue